import { BffBrandType } from '@/types/generated';

import { cacheFn } from '@utils/cacheFn';
import { getGraphHeaders } from '@utils/getGraphHeaders';
import { logWarning } from '@utils/miscUtils';

export const getBffFacilityById = cacheFn(
	async (brand: BffBrandType, id: string, url: string, appName: string, appVersion: string) => {
		try {
			if (!brand) {
				return null;
			}
			const { getGraphQLClient } = await import(
				/* webpackChunkName:"getGraphQLClient" */ '@src/lib/graphql/getGraphQLClient'
			);
			return await getGraphQLClient(url).bffFacilityById(
				{
					brand,
					id,
				},
				getGraphHeaders(appName, appVersion)
			);
		} catch (err) {
			const errorMessage = err instanceof Error ? err.message : String(err);
			logWarning(`Could not find any facilities data for: ${brand} for query: ${id}. ${errorMessage}`);
			return undefined;
		}
	}
);
